import { render } from "./QuickTabs.vue?vue&type=template&id=1b37bc92&scoped=true"
import script from "./QuickTabs.vue?vue&type=script&lang=js"
export * from "./QuickTabs.vue?vue&type=script&lang=js"

import "./QuickTabs.vue?vue&type=style&index=0&id=1b37bc92&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b37bc92"]])

export default __exports__